import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "d-grid gap-2 d-md-flex justify-content-md-end mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_yes_no = _resolveComponent("yes-no")!
  const _component_guiide_transition = _resolveComponent("guiide-transition")!
  const _component_bad_response_viewer = _resolveComponent("bad-response-viewer")!
  const _component_lock_button = _resolveComponent("lock-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h5", _hoisted_1, _toDisplayString(_ctx.name), 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_currency_input, {
        ref: "currentValue",
        description: "current value",
        elementId: "currentValue",
        onEntered: _ctx.onSaveShortcut
      }, null, 8, ["onEntered"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_yes_no, {
        questionKey: "stillPaying",
        question: "Are you still paying into the savings pots?",
        answer: _ctx.isStillPaying,
        onAnswerChanged: _ctx.onIsStillPayingAnswerChanged
      }, null, 8, ["answer", "onAnswerChanged"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_guiide_transition, {
        sectionVisible: _ctx.showHiddenSection,
        slideIn: _ctx.showContribDetail
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "alert alert-success" }, [
              _createElementVNode("i", { class: "bi bi-patch-check-fill" }),
              _createTextVNode(" Ok we will add any payments to the expected value at your target retirement date. ")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_currency_input, {
                ref: "monthlyPayment",
                description: "monthly payment",
                elementId: "monthlyPayment",
                onEntered: _ctx.onSaveShortcut
              }, null, 8, ["onEntered"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_yes_no, {
                questionKey: "willIncrease",
                question: "Will these increase if your income rises?",
                answer: _ctx.willPaymentsIncrease,
                onAnswerChanged: _ctx.onWillPaymentsIncreaseAnswerChanged
              }, null, 8, ["answer", "onAnswerChanged"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["sectionVisible", "slideIn"])
    ]),
    _createVNode(_component_bad_response_viewer, { ref: "badResponseViewer" }, null, 512),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-link text-dark text-decoration-none me-md-2",
        "aria-label": "Close",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCancelClicked && _ctx.onCancelClicked(...args)))
      }, " Cancel "),
      _createVNode(_component_lock_button, {
        text: _ctx.buttonText,
        "async-action": _ctx.onSaveClicked
      }, null, 8, ["text", "async-action"])
    ])
  ], 64))
}